export default __webpack_public_path__ + "static/media/Resources.ad242a92.svg";